/**
 * Parameters:
 * [mode={XR-only|3D-canvas}]
 * [startLobbyPageIndex=2] //startLobbyPageIndex=2
 * [startBroadcastId=<broadcastId>] //startBroadcastId=8e8a84f6-0153-11ea-af15-86d79fe38210
 * [startModelNickname=<nickname>] //startModelNickname=Model-775
 * [6dofMode={ThreeDoF|SixDoF}]
 */
import { Logger } from "../utils/Logger";
// import {Player, version as playerVersion} from "@dreamcam/web-player";
import "@dreamcam/web-player";
import { version as playerVersion } from "@dreamcam/web-player-main-thread";
// import {Player} from "@dreamcam/web-player-main-thread";
import { Version as projectionMeshVersion } from "@dreamcam/projection-mesh-babylonjs";
import { AdvancedFreeCameraMouseInput, version as babylonToolsVersion } from "@dreamcam/babylon-tools";
import { Version as awrtcBrowserVersion } from "@dreamcam/awrtc_browser";
import { MESSENGER_SDK_VERSION as messengerSdkVersion } from "@dreamcam/messenger-sdk";
import { Utils } from "./Utils";
import { BroadcastManagerState, Level, Log, SdkFactory } from "@dreamcam/web-sdk";
import { SdkFactory as MessengerSdkFactory, EUserType } from "@dreamcam/messenger-sdk";
import { SixDoFMode } from "../interfaces/SixDoFMode";
import { Core } from "../app/Core";
import { version } from "../Version";
import qs from "qs";
const ui2dDivElement = document.getElementById("ui_2d");
const webXRCanvasElement = document.getElementById("web_xr_canvas");
const videoElement = document.getElementById("video");
const switchModeElement = document.getElementById("switch_mode");
const bssUrlInput = document.getElementById("bss_url");
const nsUrlInput = document.getElementById("ns_url");
const partnerIdInput = document.getElementById("partner_id");
const partnerUrlInput = document.getElementById("partner_url");
const partnerUsernameInput = document.getElementById("partner_username");
const partnerPasswordInput = document.getElementById("partner_password");
const messengerApiUrlInput = document.getElementById("messenger_api_url");
const messengerWsUrlInput = document.getElementById("messenger_ws_url");
const fakeAuthInput = document.getElementById("fake_toggle");
const fakeAuthRow = document.getElementById("fake_row");
const offerSessionInput = document.getElementById("offer_session");
const settingsForm = document.getElementById("settings_form");
const showCategoriesSelectorInput = document.getElementById("show_categories_selector");
const filteredCategoriesInput = document.getElementById("filtered_categories");
const displayedCategoriesInput = document.getElementById("displayed_categories");
const partnerAssetsUrlInput = document.getElementById("partner_assets_url");
const customTransientPointerHandlerInput = document.getElementById("customTransientPointerHandler");
const forceExitXROnMicRequestInput = document.getElementById("forceExitXROnMicRequest");
const customGestureHandlerInput = document.getElementById("customGestureHandler");
const customGestureHandlerPinchInput = document.getElementById("customGestureHandlerPinch");
const customGestureHandlerReleaseInput = document.getElementById("customGestureHandlerRelease");
const enableGazeInputInput = document.getElementById("enableGazeInput");
const colorCorrectionInput = document.getElementById("colorCorrection");
const enableHandTrackingInput = document.getElementById("enableHandTracking");
const passthroughInput = document.getElementById("passthrough");
const userInterface = document.getElementById("user_interface");
const loginSectionElement = document.getElementById("login_section");
const logInForm = document.getElementById("login_form");
const usernameElement = document.getElementById("username");
const passwordElement = document.getElementById("password");
const logInElement = document.getElementById("log_in_button");
const logOutElement = document.getElementById("log_out_button");
const broadcastSection = document.getElementById("broadcast_section");
const openBroadcastForm = document.getElementById("open_broadcast_form");
const broadcastIdInput = document.getElementById("broadcast_id");
const modelNicknameInput = document.getElementById("model_nickname");
const videoClipIdInput = document.getElementById("video_clip_id");
const openBroadcastButton = document.getElementById("open_broadcast");
const clearBroadcastFieldsButton = document.getElementById("clear_open_broadcast_form");
const lobbySection = document.getElementById("lobby_section");
const openLobbyForm = document.getElementById("open_lobby_form");
const lobbyModeLiveInput = document.getElementById("lobby_mode_live");
const lobbyLiveFavoritesCheckbox = document.getElementById("lobby_live_favorites");
const lobbyModeVideosInput = document.getElementById("lobby_mode_videos");
const lobbyVideosModeAllInput = document.getElementById("lobby_videos_mode_all");
const lobbyVideosModePurchasedInput = document.getElementById("lobby_videos_mode_purchased");
const pageIndexInput = document.getElementById("page_index");
const openLobbyButton = document.getElementById("open_lobby");
const broadcastStateElement = document.getElementById("broadcast_state");
const requestPrivateShowButton = document.getElementById("request_private_show");
const requestAudioPrivateButton = document.getElementById("request_audio_private_show");
const stopPrivateShowButton = document.getElementById("stop_private_show");
const cancelPrivateShowRequestButton = document.getElementById("cancel_private_show_request");
const requestSpyShowButton = document.getElementById("request_spy_show");
const stopSpyShowButton = document.getElementById("stop_spy_show");
const toggleCanvasButton = document.getElementById("toggle_canvas");
const updateLobbyControls = (state) => {
    const liveEnabled = state === "Live";
    const videosEnabled = state === "Videos";
    lobbyLiveFavoritesCheckbox.disabled = !liveEnabled;
    lobbyLiveFavoritesCheckbox.labels?.forEach(l => l.style.color = liveEnabled ? "inherit" : "gray");
    lobbyVideosModeAllInput.disabled = !videosEnabled;
    lobbyVideosModeAllInput.labels?.forEach(l => l.style.color = videosEnabled ? "inherit" : "gray");
    lobbyVideosModePurchasedInput.disabled = !videosEnabled;
    lobbyVideosModePurchasedInput.labels?.forEach(l => l.style.color = videosEnabled ? "inherit" : "gray");
};
const lobbyModeSection = document.getElementById("lobby_mode_section");
lobbyModeSection.onchange = (ev) => {
    const liveEnabled = ev.target.id === lobbyModeLiveInput.id;
    const videosEnabled = ev.target.id === lobbyModeVideosInput.id;
    if (liveEnabled || videosEnabled) {
        updateLobbyControls(liveEnabled ? "Live" : "Videos");
    }
};
const returnButton = document.getElementById("return_to_private");
const supportXROnlySectionElement = (document.getElementById("support_xr_only_section"));
const resumeXRSectionElement = (document.getElementById("resume_xr_section"));
const CAMERA_MAX_ZOOM_Z = 4;
const CAMERA_MIN_ZOOM_Z = -4;
const CAMERA_INITIAL_ZOOM_Z = 0;
const CAMERA_ZOOM_SENSITIVITY = 25;
const ZOOM_STEP_Z = 1;
let currentWheelZoom = CAMERA_INITIAL_ZOOM_Z;
//let assetsUrl =  process.env.ASSETS_URL ?? "";
partnerAssetsUrlInput.value = process.env.ASSETS_URL ?? "";
(async () => {
    Logger.info(`DreamcamWebXR v${version}`);
    Logger.info(`DreamcamWebXR Assets v${await Core.getAssetsVersionAsync(partnerAssetsUrlInput.value)}`);
    Logger.info(`DreamcamWebSDK v${SdkFactory.getSdkVersion()}`);
    Logger.info(`DreamcamWebPlayer v${playerVersion}`);
    Logger.info(`MessengerSDK v${messengerSdkVersion}`);
    Logger.info(`ProjectionMeshBabylonJS v${projectionMeshVersion}`);
    Logger.info(`Babylon-tools v${babylonToolsVersion}`);
    Logger.info(`awrtc_browser: v${awrtcBrowserVersion}`);
    const lastError = localStorage.getItem("lastError");
    if (lastError) {
        Logger.error(`Previous session error: ${lastError}`);
        localStorage.removeItem("lastError");
    }
})();
var Mode;
(function (Mode) {
    Mode[Mode["default"] = 0] = "default";
    Mode[Mode["xrOnly"] = 1] = "xrOnly";
    Mode[Mode["threeDCanvas"] = 2] = "threeDCanvas";
})(Mode || (Mode = {}));
let mode = Mode.default;
let sixDoFMode = SixDoFMode.ThreeDoF;
function getUserDevice() {
    if (navigator.userAgent.includes("OculusBrowser") && /Quest(?:\s\d)?/i.test(navigator.userAgent))
        return "quest";
    if (navigator.xr !== undefined && navigator.userAgent.includes("AppleWebKit") && navigator.userAgent.includes("Safari") && navigator.userAgent.includes("Macintosh") && navigator.userAgent.includes("Intel Mac OS X"))
        return "visionpro";
    return "other";
}
const loadSettings = () => {
    const s = localStorage.getItem("dc_settings");
    if (s !== null)
        return JSON.parse(s);
    return {
        bssUrl: process.env.BSS_URL ?? "",
        nsUrl: process.env.NS_URL ?? "",
        partnerId: process.env.PARTNER_ID ?? "",
        partnerUrl: process.env.PARTNER_URL ?? "",
        messengerApiUrl: process.env.MESSENGER_API_URL ?? "",
        messengerWsUrl: process.env.MESSENGER_WS_URL ?? "",
        partnerUsername: process.env.PARTNER_USERNAME ?? "",
        partnerPassword: process.env.PARTNER_PASSWORD ?? "",
        fakeAuth: false,
    };
};
const loadAppOptions = () => {
    const s = localStorage.getItem("app_options");
    if (s !== null)
        return JSON.parse(s);
    return {
        showCategoriesSelector: true,
        filteredCategories: "",
        displayedCategories: "",
        partnerAssetsUrl: ""
    };
};
const loadCompatibilityOptions = () => {
    const device = getUserDevice();
    document.getElementById('device').innerHTML = `Device: ${device}`;
    const s = localStorage.getItem("compatibility_options");
    if (s !== null)
        return JSON.parse(s);
    switch (device) {
        case "visionpro":
            {
                return {
                    visionPro: {
                        customTransientPointerHandler: true,
                        customGestureHandler: {
                            enabled: true,
                            pinchDistance: 0.005,
                            releaseDistance: 0.01
                        },
                        enableGazeInput: true,
                        forceExitXROnMicRequest: true
                    },
                    enableHandTracking: false
                };
            }
        case "quest":
            {
                return {
                    enableHandTracking: true
                };
            }
    }
    return {};
};
const loadFeatures = () => {
    const s = localStorage.getItem("dc_features");
    if (s !== null)
        return JSON.parse(s);
    return {
        passthrough: undefined
    };
};
const saveSettings = () => {
    const settings = {
        bssUrl: bssUrlInput.value,
        nsUrl: nsUrlInput.value,
        partnerId: partnerIdInput.value,
        partnerUrl: partnerUrlInput.value,
        partnerUsername: partnerUsernameInput.value,
        partnerPassword: partnerPasswordInput.value,
        messengerApiUrl: messengerApiUrlInput.value,
        messengerWsUrl: messengerWsUrlInput.value,
        fakeAuth: fakeAuthInput.checked && !fakeAuthInput.hidden,
    };
    const appOptions = {
        showCategoriesSelector: showCategoriesSelectorInput.checked,
        filteredCategories: filteredCategoriesInput.value,
        displayedCategories: displayedCategoriesInput.value,
        partnerAssetsUrl: partnerAssetsUrlInput.value
    };
    const compatibilityOptions = {
        enableHandTracking: enableHandTrackingInput.checked,
        visionPro: {
            enableGazeInput: enableGazeInputInput.checked,
            customTransientPointerHandler: customTransientPointerHandlerInput.checked,
            forceExitXROnMicRequest: forceExitXROnMicRequestInput.checked,
            customGestureHandler: {
                enabled: customGestureHandlerInput.checked,
                pinchDistance: customGestureHandlerPinchInput.valueAsNumber,
                releaseDistance: customGestureHandlerReleaseInput.valueAsNumber
            },
            colorCorrection: colorCorrectionInput.checked
        }
    };
    const features = {
        passthrough: passthroughInput.checked ? "required" : "disabled"
    };
    localStorage.setItem("dc_settings", JSON.stringify(settings));
    localStorage.setItem("app_options", JSON.stringify(appOptions));
    localStorage.setItem("compatibility_options", JSON.stringify(compatibilityOptions));
    localStorage.setItem("dc_features", JSON.stringify(features));
};
const isEmulationMode = (urlSearchParams) => {
    const mode = (urlSearchParams.get("mode") ?? "").toLowerCase();
    return mode === "3d-canvas" || mode === "emulation";
};
const isXrOnlyMode = (urlSearchParams) => {
    const mode = (urlSearchParams.get("mode") ?? "").toLowerCase();
    return mode === "xr-only";
};
const initXR = () => {
    const urlParams = new URLSearchParams(document.location.search);
    if (isEmulationMode(urlParams)) {
        mode = Mode.threeDCanvas;
        document.documentElement.style.overflow = "hidden"; // hide scrollbars
        webXRCanvasElement.removeAttribute("hidden");
        webXRCanvasElement.width = window.innerWidth;
        webXRCanvasElement.height = window.innerHeight;
        Utils.setVisibility(videoElement, false);
    }
    else if (isXrOnlyMode(urlParams)) {
        mode = Mode.xrOnly;
    }
    else {
        mode = Mode.default;
    }
    //TODO DZZ For debug XR emulation. Comment in production.
    // webXRCanvasElement.removeAttribute("hidden");
    const sixDoFModeParam = urlParams.get("6dofMode");
    if (sixDoFModeParam) {
        sixDoFMode = SixDoFMode[sixDoFModeParam];
    }
};
const partnerTokenGenerator = async (username, password) => {
    const partnerUrl = partnerUrlInput?.value ?? process.env.PARTNER_URL;
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    const partnerUsername = partnerUsernameInput?.value ?? process.env.PARTNER_USERNAME;
    const partnerPassword = partnerPasswordInput?.value ?? process.env.PARTNER_PASSWORD;
    if (partnerUsername && partnerPassword && partnerUsername !== "" && partnerPassword !== "") {
        headers["Authorization"] = `Basic ${btoa(`${partnerUsername}:${partnerPassword}`)}`;
    }
    const config = {
        method: "POST",
        headers: headers,
        body: `login=${username}&password=${password}`,
    };
    const response = await fetch(partnerUrl, config);
    const json = await response.json();
    return json.session;
};
export var State;
(function (State) {
    State[State["flatLobby"] = 0] = "flatLobby";
    State[State["flatBroadcast"] = 1] = "flatBroadcast";
    State[State["invitationToEnterXR"] = 2] = "invitationToEnterXR";
    State[State["invitationToResumeXR"] = 3] = "invitationToResumeXR";
    State[State["xr"] = 4] = "xr";
})(State || (State = {}));
let core = null;
let sdk;
let messengerSdk;
let _accessToken = "";
let _refreshToken = "";
let _partnerUserId = "";
const DREAMCAM_PARTNER_ID = "dreamcam_oauth2";
export let showSectionAsync = undefined;
const saveInputValue = (input) => {
    localStorage.setItem(input.id, input.value);
};
const loadInputValue = (input) => {
    input.value = localStorage.getItem(input.id) ?? "";
};
loadInputValue(broadcastIdInput);
loadInputValue(modelNicknameInput);
loadInputValue(videoClipIdInput);
loadInputValue(lobbyModeLiveInput);
loadInputValue(lobbyLiveFavoritesCheckbox);
loadInputValue(lobbyModeVideosInput);
loadInputValue(lobbyVideosModeAllInput);
loadInputValue(lobbyVideosModePurchasedInput);
loadInputValue(usernameElement);
loadInputValue(passwordElement);
pageIndexInput.value = "0";
const updateSwitchModeElementText = (isXRMode) => {
    switchModeElement.innerText = isXRMode ? "Exit VR" : "Enter VR";
    Utils.setVisibility(userInterface, !isXRMode);
};
const topUpAsync = async (pageParams) => {
    console.log("TopUp pageParams:", JSON.stringify(pageParams));
    if (getCore().isXRMode) {
        await getCore().exitXRAsync();
    }
    window.open("https://google.com/search?q=topUp");
};
const onEnterXRAsync = async (pageParams) => {
    // console.log(`%cOnEnterXR pageParams: ${JSON.stringify(pageParams)}`, "background-color: yellowgreen");
    console.log(`OnEnterXR pageParams: ${JSON.stringify(pageParams)}`);
    await updatePlayerAsync(sdk.broadcastManager.currentStream);
    Utils.setVisibility(returnButton, false);
};
const onExitXRAsync = async (pageParams) => {
    // console.log(`%cOnExitXR pageParams: ${JSON.stringify(pageParams)}`, "background-color: yellowgreen");
    console.log(`OnExitXR pageParams: ${JSON.stringify(pageParams)}`);
    broadcastIdInput.value = sdk.broadcastManager.broadcastId ?? "";
    modelNicknameInput.value = sdk.broadcastManager.broadcast?.modelNickname ?? "";
    videoClipIdInput.value = sdk.galleryManager.videoClip?.id.toString() ?? "";
    const pageIndex = sdk.catalogManager.pagination?.pageIndex ?? 0;
    pageIndexInput.value = pageIndex.toString();
    lobbyModeLiveInput.checked = pageParams.lobbyPageParams?.lobbyMode === "Live";
    lobbyModeVideosInput.checked = pageParams.lobbyPageParams?.lobbyMode === "Videos";
    lobbyLiveFavoritesCheckbox.checked = sdk.catalogManager.filter.favoritesOnly;
    lobbyVideosModeAllInput.checked = pageParams.lobbyPageParams?.lobbyVideosMode === "AllVideos";
    lobbyVideosModePurchasedInput.checked = pageParams.lobbyPageParams?.lobbyVideosMode === "Purchased";
    updateLobbyControls(lobbyModeLiveInput.checked ? "Live" : "Videos");
    saveInputValue(videoClipIdInput);
    saveInputValue(modelNicknameInput);
    saveInputValue(broadcastIdInput);
    saveInputValue(pageIndexInput);
    updateSwitchModeElementText(false);
    await updatePlayerAsync(sdk.broadcastManager.currentStream);
};
const onMicrophonePermissionResolved = (granted) => {
    returnButton.style.backgroundColor = granted ? "green" : "red";
    Utils.setVisibility(returnButton, true);
};
const getWebXRParams = () => {
    const partnerId = partnerIdInput.value;
    const isTrue = (value) => {
        return value?.toLowerCase() === "true";
    };
    const params = {
        canvas: webXRCanvasElement,
        video: videoElement,
        emulation: mode === Mode.threeDCanvas,
        sixDoFMode: sixDoFMode,
        enableGtm: false,
        isReleaseMode: isTrue(process.env.IS_RELEASE),
        showFps: isTrue(process.env.SHOW_FPS),
        showHiddenBroadcasts: isTrue(process.env.SHOW_HIDDEN_BROADCASTS),
        showOfflineBroadcasts: true,
        showCategoriesSelector: showCategoriesSelectorInput.checked,
        displayedCategoriesArray: displayedCategoriesInput.value.trim() === "" ? [] : displayedCategoriesInput.value.split(","),
        assetsUrl: partnerAssetsUrlInput.value,
        textsUrl: process.env.TEXTS_URL,
        globalOptionsUrl: process.env.OPTIONS_URL,
        topUpAsync,
        onEnterXRAsync,
        onExitXRAsync,
        onMicrophonePermissionResolved,
    };
    if (fakeAuthInput.checked) {
        if (partnerId === DREAMCAM_PARTNER_ID) {
            return {
                ...params,
                loginApiAuthAsync: async (login, password) => {
                    console.log(`Login email: ${login}, password: ${password.replace(/./g, '*')}`);
                    try {
                        const response = await fetch(`${partnerUrlInput.value}/loginApiAuth`, {
                            method: "POST",
                            headers: { "Content-Type": "application/x-www-form-urlencoded" },
                            body: qs.stringify({
                                login: process.env.DEV_USERNAME,
                                password: process.env.DEV_PASSWORD
                            })
                        });
                        const json = await response.json();
                        // Save tokens and partnerUserId for future refresh
                        _accessToken = json.session ?? _accessToken;
                        _refreshToken = json.refresh_token ?? _refreshToken;
                        window.refreshToken = json.refresh_token ?? window.refreshToken;
                        _partnerUserId = json.partnerId ?? _partnerUserId;
                        return { ...json };
                    }
                    catch (e) {
                        return { status: "error", message: "Network Error" };
                    }
                },
                logoutApiAuthAsync: async (access_token, refresh_token) => {
                    try {
                        const response = await fetch(`${partnerUrlInput.value}/logoutApiAuth`, {
                            method: "POST",
                            headers: { "Content-Type": "application/x-www-form-urlencoded" },
                            body: qs.stringify({
                                access_token: access_token != "" ? access_token : _accessToken,
                                refresh_token: refresh_token != "" ? refresh_token : _refreshToken
                            })
                        });
                        const json = await response.json();
                        return { ...json };
                    }
                    catch (e) {
                        return { status: "error", message: "Network Error" };
                    }
                },
                signupApiAuthAsync: async (username, login, password, confirm_password) => {
                    console.log(`Signup username: ${username}, email: ${login}, password: ${password}, confirm_password: ${confirm_password}`);
                    await new Promise(r => setTimeout(r, 2000));
                    return {
                        status: "error",
                        message: "wrong credentials",
                        errors: [{ field: "email", error: "email error" }, {
                                field: "username",
                                error: "username error"
                            }, { field: "password", error: "password error" }]
                    };
                },
            };
        }
        else {
            return {
                ...params,
                loginAsync: async (params) => {
                    console.log(`Login params:`, params);
                    const token = await partnerTokenGenerator(process.env.DEV_USERNAME ?? "", process.env.DEV_PASSWORD ?? "");
                    await sdk.authManager.loginAsync(process.env.DEV_USERNAME ?? "", process.env.DEV_USERNAME ?? "", token);
                },
                logoutAsync: async (params) => {
                    console.log(`Logout params:`, params);
                    // sdk.authManager.logoutAsync();
                },
                signupAsync: async (params) => {
                    console.log(`Signup params:`, params);
                    const token = process.env.DEV_TOKEN ?? await partnerTokenGenerator(process.env.DEV_USERNAME ?? "", process.env.DEV_PASSWORD ?? "");
                    await sdk.authManager.loginAsync(process.env.DEV_USERNAME ?? "", process.env.DEV_USERNAME ?? "", token);
                },
            };
        }
    }
    else {
        if (partnerId === DREAMCAM_PARTNER_ID) {
            return {
                ...params,
                loginApiAuthAsync: async (login, password) => {
                    console.log(`Login email: ${login}, password: ${password.replace(/./g, '*')}`);
                    try {
                        const response = await fetch(`${partnerUrlInput.value}/loginApiAuth`, {
                            method: "POST",
                            headers: { "Content-Type": "application/x-www-form-urlencoded" },
                            body: qs.stringify({
                                login: login,
                                password: password,
                            })
                        });
                        const json = await response.json();
                        // Save tokens and partnerUserId for future refresh
                        _accessToken = json.session ?? _accessToken;
                        _refreshToken = json.refresh_token ?? _refreshToken;
                        window.refreshToken = json.refresh_token ?? window.refreshToken;
                        _partnerUserId = json.partnerId ?? _partnerUserId;
                        return { ...json };
                    }
                    catch (e) {
                        return { status: "error", message: "Network Error" };
                    }
                },
                logoutApiAuthAsync: async (access_token, refresh_token) => {
                    try {
                        const response = await fetch(`${partnerUrlInput.value}/logoutApiAuth`, {
                            method: "POST",
                            headers: { "Content-Type": "application/x-www-form-urlencoded" },
                            body: qs.stringify({
                                access_token: access_token != "" ? access_token : _accessToken,
                                refresh_token: refresh_token != "" ? refresh_token : _refreshToken
                            })
                        });
                        const json = await response.json();
                        return { ...json };
                    }
                    catch (e) {
                        return { status: "error", message: "Network Error" };
                    }
                },
                signupApiAuthAsync: async (username, login, password, confirm_password) => {
                    console.log(`Signup username: ${username}, email: ${login}, password: ${password}, confirm_password: ${confirm_password}`);
                    try {
                        const response = await fetch(`${partnerUrlInput.value}/signupApiAuth`, {
                            method: "POST",
                            headers: { "Content-Type": "application/x-www-form-urlencoded" },
                            body: qs.stringify({
                                username,
                                login,
                                password,
                                confirm_password
                            })
                        });
                        const json = await response.json();
                        return { ...json };
                    }
                    catch (e) {
                        return { status: "error", message: "Network Error" };
                    }
                },
            };
        }
        else {
            return {
                ...params,
                loginAsync: async (params) => {
                    console.log(`Login params:`, params);
                    if (getCore().isXRMode) {
                        await getCore().exitXRAsync();
                    }
                    window.open("https://google.com/search?q=signIn");
                },
                logoutAsync: async (params) => {
                    console.log(`Logout params:`, params);
                },
                signupAsync: async (params) => {
                    console.log(`Signup params:`, params);
                    if (getCore().isXRMode) {
                        await getCore().exitXRAsync();
                    }
                    window.open("https://google.com/search?q=signUp");
                },
            };
        }
    }
};
const getCore = () => {
    if (core !== null)
        return core;
    // const envSettings = await getEnvSettingsAsync();
    const webXRParams = getWebXRParams();
    core = Core.createInstance({
        sdk,
        messengerSdk,
        webXRParams,
        sitePageParams: {
            lobbyPageParams: {
            //TODO DZZ DCVR-5579: Remove this line.
            //lobbyMode: "Videos",
            },
        },
        compatibilityOptions: {
            enableHandTracking: enableHandTrackingInput.checked,
            visionPro: {
                enableGazeInput: enableGazeInputInput.checked,
                customTransientPointerHandler: customTransientPointerHandlerInput.checked,
                forceExitXROnMicRequest: forceExitXROnMicRequestInput.checked,
                customGestureHandler: {
                    enabled: customGestureHandlerInput.checked,
                    pinchDistance: customGestureHandlerPinchInput.valueAsNumber,
                    releaseDistance: customGestureHandlerReleaseInput.valueAsNumber
                },
                colorCorrection: colorCorrectionInput.checked
            }
        },
        features: {
            passthrough: passthroughInput.checked ? "required" : "disabled"
        }
    });
    return core;
};
const updatePlayerAsync = async (streamInfo) => {
    if (getCore().isXRMode)
        return;
    const player = videoElement;
    const videoClip = sdk.galleryManager.videoClip;
    if (videoClip) {
        if (videoClip.videoUrl) {
            player.src = videoClip.videoUrl;
            await player.play();
        }
    }
    else {
        const bmState = sdk.broadcastManager.state;
        if (bmState === BroadcastManagerState.UNINITIALIZED || (core?.isXRMode === true) || mode === Mode.threeDCanvas) {
            await videoElement.stop();
        }
        else {
            const url = streamInfo?.status === "online" ? (streamInfo.url ?? "") : "";
            if (url === "")
                return;
            const lowLatency = streamInfo !== null && streamInfo.useLowLatency === true;
            videoElement.lowLatency = lowLatency;
            if (videoElement.currentSrc !== url) {
                videoElement.src = url;
                await player.play();
            }
        }
    }
};
const init = async () => {
    Utils.setVisibility(settingsForm, false);
    Utils.setVisibility(userInterface, true);
    Utils.setVisibility(videoElement, false);
    // {
    //     await loadGlobalOptionsAsync(process.env.OPTIONS_URL);
    //     Utils.setVisibility(lobbyVideoClipIdSection, true);
    //     Utils.setVisibility(lobbyModeSection, true);
    // }
    const setAuthVisibilityAsync = async () => {
        Utils.setVisibility(usernameElement, !sdk.authManager.isAuthorized);
        Utils.setVisibility(passwordElement, !sdk.authManager.isAuthorized);
        Utils.setVisibility(logInForm, !sdk.authManager.isAuthorized);
        Utils.setVisibility(logOutElement, sdk.authManager.isAuthorized);
    };
    const onUnauthorizedRequestAsync = async () => {
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded"
        };
        const url = Utils.concatUrl(partnerUrlInput.value, "refresh");
        const refreshTokenValue = window.refreshToken || _refreshToken;
        console.log("[AUTH][refresh] start", {
            url,
            hasRefreshToken: Boolean(refreshTokenValue),
            partnerUserId: _partnerUserId || null
        });
        const response = await fetch(url, {
            method: "POST",
            headers: headers,
            body: qs.stringify({ refresh_token: refreshTokenValue }),
        });
        console.log("[AUTH][refresh] response", response.status, response.statusText);
        if (!response.ok) {
            console.warn("[AUTH][refresh] failed", { status: response.status, statusText: response.statusText });
            throw new Error(`Refresh failed: ${response.status} ${response.statusText}`);
        }
        const { access_token, refresh_token } = await response.json();
        window.refreshToken = refresh_token;
        _refreshToken = refresh_token;
        console.log("[AUTH][refresh] success", {
            partnerUserId: _partnerUserId || null,
            accessTokenTail: typeof access_token === "string" ? access_token.slice(-6) : undefined,
            refreshTokenTail: typeof refresh_token === "string" ? refresh_token.slice(-6) : undefined,
        });
        return {
            clientNickname: sdk.authManager.authResponse.clientNickname,
            // здесь должен быть последний partnerUserId после авторизации у партнера вместо usernameElement.value
            partnerUserId: _partnerUserId || usernameElement.value || process.env.DEV_USERNAME || "",
            partnerSessionToken: access_token,
        };
    };
    const onMessengerUnauthorizedRequestAsync = async () => {
        //console.log("MSG:  Token expired - re-authenticating messenger via /auth API...");
        const bssAuthResponse = sdk.authManager.authResponse;
        if (!bssAuthResponse) {
            console.log("MSG:  BSS not authenticated");
            throw new Error("BSS not authenticated");
        }
        const bssSessionId = bssAuthResponse.clientSessionToken;
        const bssClientId = bssAuthResponse.clientId;
        //console.log("MSG: Using BSS session:", bssSessionId.slice(0, 10) + "...");
        //console.log("MSG: BSS Client ID:", bssClientId);
        try {
            const headers = {
                "Content-Type": "application/json"
            };
            const url = Utils.concatUrl(messengerApiUrlInput.value, "api/auth");
            //console.log("MSG: Calling auth API:", url);
            const response = await fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify({
                    bss_session_id: bssSessionId,
                    user_type: "user"
                }),
            });
            if (!response.ok) {
                throw new Error(`MSG auth API failed: ${response.status} ${response.statusText}`);
            }
            const { client_session_token } = await response.json();
            //console.log("MSG:  New client session token received:", client_session_token.slice(0, 5) + "...");
            const result = {
                user_id: bssClientId,
                chat_client_id: bssClientId,
                user_type: EUserType.USER,
                bss_session_id: bssSessionId,
                client_session_token: client_session_token
            };
            //console.log("MSG:  Token refresh completed successfully - messenger should apply new token");
            return result;
        }
        catch (error) {
            //console.error("MSG:  Failed to re-authenticate messenger:", error);
            throw error;
        }
    };
    sdk = SdkFactory.createInstance({
        bss: {
            baseUrl: bssUrlInput.value,
            partnerId: partnerIdInput.value,
            onUnauthorizedRequestAsync: onUnauthorizedRequestAsync,
        },
        ns: {
            url: nsUrlInput.value,
            pingIntervalInMillis: 5_000,
        },
        logger: {
            level: Level.Debug,
        },
    });
    messengerSdk = MessengerSdkFactory.createInstance({
        baseUrl: messengerApiUrlInput.value,
        baseWsUrl: messengerWsUrlInput.value,
        pingIntervalInMillis: 5000,
        onUnauthorizedRequestAsync: onMessengerUnauthorizedRequestAsync,
        options: {
            isChatsSort: true,
        },
    });
    sdk.catalogManager.filter.categoriesFilter = filteredCategoriesInput.value;
    //TODO DZZ Comment this line!
    // await sdk.broadcastManager.enterRoomByModelNicknameAsync("Model-775");
    sdk.broadcastManager.useLegacyStreamSelector = false;
    sdk.authManager.addListener("loggedIn", async () => {
        // console.log("++++++ (1) index.ts: loggedIn");
        // const bssAuthResponse = sdk.authManager.authResponse;
        // if (bssAuthResponse) {
        //     const bssSessionId = bssAuthResponse.clientSessionToken;
        //     const bssClientId = bssAuthResponse.clientId;
        //     console.log("++++++ (2) index.ts: loggedIn");
        //     await messengerSdk.authManager.loginAsync(bssSessionId, EUserType.USER, bssClientId);
        //     console.log("++++++ (3) index.ts: loggedIn");
        // }
        await setAuthVisibilityAsync();
    });
    sdk.authManager.addListener("loggedOut", async () => {
        if (messengerSdk.authManager.authResponse) {
            await messengerSdk.authManager.logoutAsync();
        }
        await setAuthVisibilityAsync();
    });
    sdk.authManager.addListener("incompleteSessionFound", a => sdk.broadcastManager.enterRoomAndRestorePrivateShowAsync(a.existingShow));
    sdk.broadcastManager.addListener("onActionsChanged", a => {
        requestPrivateShowButton.disabled = !a.canUseRequestPrivateShow;
        requestAudioPrivateButton.disabled = !a.canUseRequestVoicePrivateShow;
        stopPrivateShowButton.disabled = !a.canUseCancelPrivateShow;
        cancelPrivateShowRequestButton.disabled = !a.canUseCancelPrivateShowRequest;
        requestSpyShowButton.disabled = !a.canUseEnterSpyShow;
        stopSpyShowButton.disabled = !a.canUseLeaveSpyShow;
    });
    sdk.broadcastManager.addListener("onStateChanged", (a) => {
        broadcastStateElement.innerText = a.state;
        if (a.state === "UNINITIALIZED") {
            broadcastIdInput.value = "";
            modelNicknameInput.value = "";
        }
        else {
            broadcastIdInput.value = sdk.broadcastManager.broadcastId ?? "";
            modelNicknameInput.value = sdk.broadcastManager.broadcast?.modelNickname ?? "";
        }
        saveInputValue(modelNicknameInput);
        saveInputValue(broadcastIdInput);
    });
    sdk.broadcastManager.addListener("onCurrentStreamChanged", async (args) => {
        args.notifications.forEach(n => Log.warn(n));
        await updatePlayerAsync(args.streamInfo);
    });
    //DONE DZZ DCVR-6517 Auto-login: remove this block!
    // {
    //     const response = await axios.post(`${partnerUrlInput.value}/loginApiAuth`,
    //         qs.stringify({
    //             login: process.env.DEV_USERNAME,
    //             password: process.env.DEV_PASSWORD,
    //         }));
    //     _accessToken = response.data.session;
    //     _refreshToken = response.data.refresh_token;
    //     const partnerUserId: string = response.data.partnerId;
    //     const partnerToken = response.data.session;
    //
    //     await sdk.authManager.loginAsync(response.data.clientId, partnerUserId, partnerToken);
    //
    //     const bssAuthResponse = sdk.authManager.authResponse;
    //     if (bssAuthResponse) {
    //         const bssSessionId = bssAuthResponse.clientSessionToken;
    //         const bssClientId = bssAuthResponse.clientId;
    //         await messengerSdk.authManager.loginAsync(bssSessionId, EUserType.USER, bssClientId);
    //     }
    // }
    try {
        await getCore().initAsync();
    }
    catch (error) {
        console.error(error.message);
        localStorage.setItem("lastError", error.message);
        window.location.reload();
        return;
    }
    if (offerSessionInput.checked)
        await getCore().offerXRSessionAsync();
    if (mode === Mode.threeDCanvas) {
        getCore().camera.inputs.removeMouse();
        getCore().camera.inputs.removeByType("keyboard");
        getCore().camera.inputs.add(new AdvancedFreeCameraMouseInput({
            rotationXLimit: 90 * 2,
            rotationYLimit: 90,
            moveXSensitivity: 2000,
            moveYSensitivity: 2000
        }));
        webXRCanvasElement.addEventListener('wheel', (event) => {
            if (!event.shiftKey)
                return;
            if (event.deltaY > 0) {
                if (currentWheelZoom <= CAMERA_MIN_ZOOM_Z)
                    return;
                getCore().camera.fov += ZOOM_STEP_Z / CAMERA_ZOOM_SENSITIVITY;
                currentWheelZoom -= ZOOM_STEP_Z;
            }
            else {
                if (currentWheelZoom >= CAMERA_MAX_ZOOM_Z)
                    return;
                getCore().camera.fov -= ZOOM_STEP_Z / CAMERA_ZOOM_SENSITIVITY;
                currentWheelZoom += ZOOM_STEP_Z;
            }
            event.preventDefault();
        }, { capture: false, passive: true });
        await getCore().showSceneAsync();
        // Utils.setVisibility(toggleCanvasButton,true);
        Utils.setVisibility(toggleCanvasButton, false);
    }
    showSectionAsync = async (state) => {
        const isXRMode = core !== null && core.isXRMode;
        Utils.setVisibility(supportXROnlySectionElement, state === State.invitationToEnterXR);
        Utils.setVisibility(resumeXRSectionElement, state === State.invitationToResumeXR);
        Utils.setVisibility(loginSectionElement, !isXRMode &&
            mode !== Mode.threeDCanvas &&
            mode !== Mode.xrOnly);
        Utils.setVisibility(broadcastSection, !isXRMode &&
            mode !== Mode.threeDCanvas &&
            mode !== Mode.xrOnly);
        Utils.setVisibility(lobbySection, !isXRMode &&
            mode !== Mode.threeDCanvas &&
            mode !== Mode.xrOnly);
        updateSwitchModeElementText(isXRMode);
        Utils.setVisibility(switchModeElement, mode !== Mode.threeDCanvas && (await Core.isXRModeSupportedAsync()));
        await setAuthVisibilityAsync();
    };
    switchModeElement.addEventListener("click", async () => {
        switchModeElement.disabled = true;
        try {
            const isXr = getCore().isXRMode;
            if (isXr) {
                await getCore().exitXRAsync();
                updateSwitchModeElementText(false);
            }
            else {
                sdk.catalogManager.filter.favoritesOnly = lobbyLiveFavoritesCheckbox.checked;
                const sitePageParams = {
                    lobbyPageParams: {
                        lobbyMode: lobbyModeVideosInput.checked ? "Videos" : "Live",
                        lobbyVideosMode: lobbyVideosModePurchasedInput.checked ? "Purchased" : "AllVideos",
                    },
                    broadcastPageParams: {
                        broadcastId: broadcastIdInput.value === "" ? undefined : broadcastIdInput.value,
                        modelNickname: modelNicknameInput.value === "" ? undefined : modelNicknameInput.value,
                        videoClip: videoClipIdInput.value === "" ? undefined : { id: parseInt(videoClipIdInput.value) },
                    },
                };
                if (sdk.galleryManager.videoClip && sitePageParams.broadcastPageParams?.videoClip?.id !== sdk.galleryManager.videoClip.id) {
                    sdk.galleryManager.closeVideoClip();
                }
                if (sdk.broadcastManager.broadcast &&
                    sitePageParams.broadcastPageParams?.broadcastId !== sdk.broadcastManager.broadcast.id &&
                    sitePageParams.broadcastPageParams?.modelNickname !== sdk.broadcastManager.broadcast.modelNickname) {
                    await sdk.broadcastManager.leaveRoomAsync();
                }
                if (sitePageParams.broadcastPageParams?.videoClip) {
                    const paramsVideoClip = sitePageParams.broadcastPageParams.videoClip;
                    if (sdk.galleryManager.videoClip?.id !== paramsVideoClip.id) {
                        const videoClip = await sdk.galleryManager.openVideoClipAsync(paramsVideoClip.id, { loadStreamData: true });
                        await sdk.broadcastManager.enterRoomByModelNicknameAsync(videoClip.modelNickname);
                    }
                }
                else if (sitePageParams.broadcastPageParams?.modelNickname) {
                    const modelNickname = sitePageParams.broadcastPageParams.modelNickname;
                    await sdk.broadcastManager.enterRoomByModelNicknameAsync(modelNickname);
                }
                else if (sitePageParams.broadcastPageParams?.broadcastId) {
                    const broadcastId = sitePageParams.broadcastPageParams.broadcastId;
                    await sdk.broadcastManager.enterRoomAsync(broadcastId);
                }
                await getCore().enterXRAsync(sitePageParams);
                updateSwitchModeElementText(true);
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            switchModeElement.disabled = false;
        }
    });
    returnButton.addEventListener("click", async () => {
        returnButton.disabled = true;
        try {
            await getCore().enterXRAsync();
            updateSwitchModeElementText(true);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            returnButton.disabled = false;
        }
    });
    logInForm.addEventListener("submit", async (ev) => {
        ev.preventDefault();
        logInElement.disabled = true;
        try {
            let partnerToken = "";
            if (partnerIdInput.value === DREAMCAM_PARTNER_ID) {
                try {
                    const response = await fetch(`${partnerUrlInput.value}/loginApiAuth`, {
                        method: "POST",
                        headers: { "Content-Type": "application/x-www-form-urlencoded" },
                        body: qs.stringify({ login: fakeAuthInput.checked ? process.env.DEV_USERNAME : usernameElement.value, password: fakeAuthInput.checked ? process.env.DEV_PASSWORD : passwordElement.value })
                    });
                    const json = await response.json();
                    _accessToken = json.session;
                    _refreshToken = json.refresh_token;
                    window.refreshToken = json.refresh_token;
                    const partnerUserId = json.partnerId;
                    partnerToken = json.session;
                    await sdk.authManager.loginAsync(json.clientId, partnerUserId, partnerToken);
                    _partnerUserId = partnerUserId || "";
                    saveInputValue(usernameElement);
                    saveInputValue(passwordElement);
                }
                catch (e) {
                    if (e.code === 401) {
                        console.error(e.message);
                        return;
                    }
                    else {
                        throw (e);
                    }
                }
            }
            else {
                partnerToken = await partnerTokenGenerator(usernameElement.value, passwordElement.value);
                await sdk.authManager.loginAsync(usernameElement.value, usernameElement.value, partnerToken);
                _partnerUserId = usernameElement.value || "";
            }
            await setAuthVisibilityAsync();
        }
        finally {
            logInElement.disabled = false;
        }
    });
    logOutElement.addEventListener("click", async () => {
        logOutElement.disabled = true;
        try {
            if (partnerIdInput.value === DREAMCAM_PARTNER_ID) {
                await fetch(`${partnerUrlInput.value}/logoutApiAuth`, {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: qs.stringify({ access_token: _accessToken, refresh_token: _refreshToken })
                });
            }
            await sdk.authManager.logoutAsync();
            _partnerUserId = "";
            await setAuthVisibilityAsync();
        }
        finally {
            logOutElement.disabled = false;
        }
    });
    openBroadcastForm.addEventListener("submit", async (ev) => {
        ev.preventDefault();
        openBroadcastButton.disabled = true;
        try {
            if (videoClipIdInput.value.length > 0) {
                const videoClip = await sdk.galleryManager.openVideoClipAsync(videoClipIdInput.valueAsNumber);
                if (videoClip)
                    await sdk.broadcastManager.enterRoomByModelNicknameAsync(videoClip.modelNickname);
                await updatePlayerAsync(null);
            }
            else if (modelNicknameInput.value.length > 0) {
                sdk.galleryManager.closeVideoClip();
                await sdk.broadcastManager.enterRoomByModelNicknameAsync(modelNicknameInput.value);
            }
            else if (broadcastIdInput.value.length > 0) {
                sdk.galleryManager.closeVideoClip();
                await sdk.broadcastManager.enterRoomAsync(broadcastIdInput.value);
            }
            modelNicknameInput.value = sdk.broadcastManager.broadcast?.modelNickname ?? "";
            broadcastIdInput.value = sdk.broadcastManager.broadcastId ?? "";
            if (sdk.galleryManager.videoClip)
                videoClipIdInput.valueAsNumber = sdk.galleryManager.videoClip.id;
            Utils.setVisibility(videoElement, sdk.broadcastManager.broadcast !== null);
            saveInputValue(modelNicknameInput);
            saveInputValue(broadcastIdInput);
            saveInputValue(videoClipIdInput);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            openBroadcastButton.disabled = false;
        }
    });
    clearBroadcastFieldsButton.addEventListener("click", (ev) => {
        ev.preventDefault();
        broadcastIdInput.value = "";
        modelNicknameInput.value = "";
        videoClipIdInput.value = "";
        saveInputValue(modelNicknameInput);
        saveInputValue(broadcastIdInput);
        saveInputValue(videoClipIdInput);
    });
    openLobbyForm.addEventListener("submit", async (ev) => {
        ev.preventDefault();
        openLobbyButton.disabled = true;
        try {
            modelNicknameInput.value = "";
            broadcastIdInput.value = "";
            videoClipIdInput.value = "";
            Utils.setVisibility(videoElement, false);
            sdk.galleryManager.closeVideoClip();
            await sdk.broadcastManager.leaveRoomAsync();
            if (lobbyModeLiveInput.checked) {
                sdk.catalogManager.filter.favoritesOnly = lobbyLiveFavoritesCheckbox.checked;
                const broadcasts = await sdk.catalogManager.loadPageAsync(pageIndexInput.valueAsNumber, 12, null, {
                    showOffline: true,
                    showHidden: process.env.SHOW_HIDDEN_BROADCASTS?.toLowerCase() === "true",
                    includeFavorites: true,
                });
                console.log(`Broadcasts on page #${pageIndexInput.valueAsNumber}`, broadcasts);
            }
            else if (lobbyModeVideosInput.checked) {
                if (lobbyVideosModeAllInput.checked) {
                    const videoClips = await sdk.galleryManager.loadVideoClipsPageAsync(pageIndexInput.valueAsNumber, 12);
                    console.log(`VideoClips on page #${pageIndexInput.valueAsNumber}`, videoClips);
                }
                else if (lobbyVideosModePurchasedInput.checked) {
                    try {
                        const itemPurchases = await sdk.galleryManager.loadVideoClipPurchasesPageAsync(pageIndexInput.valueAsNumber, 12, null);
                        console.log(`Purchased VideoClips on page #${pageIndexInput.valueAsNumber}`, itemPurchases);
                    }
                    catch (e) {
                        if (e.code === 401) {
                            console.error(e.message);
                        }
                        else {
                            console.error(e);
                        }
                    }
                }
            }
            saveInputValue(modelNicknameInput);
            saveInputValue(broadcastIdInput);
            saveInputValue(videoClipIdInput);
            saveInputValue(lobbyModeLiveInput);
            saveInputValue(lobbyLiveFavoritesCheckbox);
            saveInputValue(lobbyModeVideosInput);
            saveInputValue(lobbyVideosModeAllInput);
            saveInputValue(lobbyVideosModePurchasedInput);
            saveInputValue(pageIndexInput);
        }
        finally {
            openLobbyButton.disabled = false;
        }
    });
    requestPrivateShowButton.addEventListener("click", async () => {
        await sdk.broadcastManager.requestPrivateShowAsync();
    });
    requestAudioPrivateButton.addEventListener("click", async () => {
        await sdk.broadcastManager.requestVoicePrivateShowAsync();
    });
    stopPrivateShowButton.addEventListener("click", async () => {
        await sdk.broadcastManager.cancelPrivateShowAsync();
    });
    cancelPrivateShowRequestButton.addEventListener("click", async () => {
        await sdk.broadcastManager.cancelPrivateShowAsync();
    });
    requestSpyShowButton.addEventListener("click", async () => {
        await sdk.broadcastManager.requestSpyShowAsync();
    });
    stopSpyShowButton.addEventListener("click", async () => {
        await sdk.broadcastManager.cancelSpyShowAsync();
    });
    toggleCanvasButton.addEventListener("pointerenter", () => {
        if (getCore().appController.inputHelper !== undefined)
            getCore().appController.inputHelper.inputsEnabled = false;
    });
    toggleCanvasButton.addEventListener("pointerleave", () => {
        if (getCore().appController.inputHelper !== undefined)
            getCore().appController.inputHelper.inputsEnabled = true;
    });
    toggleCanvasButton.addEventListener("click", () => {
        webXRCanvasElement.hidden = !webXRCanvasElement.hidden;
    });
    await showSectionAsync();
};
const settings = loadSettings();
bssUrlInput.value = settings.bssUrl;
nsUrlInput.value = settings.nsUrl;
partnerIdInput.value = settings.partnerId;
partnerUrlInput.value = settings.partnerUrl;
partnerUsernameInput.value = settings.partnerUsername;
partnerPasswordInput.value = settings.partnerPassword;
fakeAuthRow.hidden = process.env.DEV_USERNAME === undefined || process.env.DEV_PASSWORD === undefined;
messengerApiUrlInput.value = settings.messengerApiUrl;
messengerWsUrlInput.value = settings.messengerWsUrl;
if (fakeAuthRow.hidden)
    settings.fakeAuth = false;
fakeAuthInput.checked = settings.fakeAuth && !fakeAuthInput.hidden;
const appOptions = loadAppOptions();
showCategoriesSelectorInput.checked = appOptions.showCategoriesSelector ?? true;
filteredCategoriesInput.value = appOptions.filteredCategories ?? "";
displayedCategoriesInput.value = appOptions.displayedCategories ?? "";
partnerAssetsUrlInput.value = appOptions.partnerAssetsUrl ?? "";
const compatibilityOptions = loadCompatibilityOptions();
enableHandTrackingInput.checked = compatibilityOptions.enableHandTracking ?? false;
enableGazeInputInput.checked = compatibilityOptions.visionPro?.enableGazeInput ?? false;
customTransientPointerHandlerInput.checked = compatibilityOptions.visionPro?.customTransientPointerHandler ?? false;
forceExitXROnMicRequestInput.checked = compatibilityOptions.visionPro?.forceExitXROnMicRequest ?? false;
customGestureHandlerInput.checked = compatibilityOptions.visionPro?.customGestureHandler?.enabled ?? false;
customGestureHandlerPinchInput.valueAsNumber = compatibilityOptions.visionPro?.customGestureHandler?.pinchDistance ?? 0.005;
customGestureHandlerReleaseInput.valueAsNumber = compatibilityOptions.visionPro?.customGestureHandler?.releaseDistance ?? 0.01;
colorCorrectionInput.checked = compatibilityOptions.visionPro?.colorCorrection ?? false;
customGestureHandlerPinchInput.disabled = !customGestureHandlerInput.checked;
customGestureHandlerReleaseInput.disabled = !customGestureHandlerInput.checked;
const features = loadFeatures();
passthroughInput.checked = features.passthrough === "required";
customGestureHandlerInput.addEventListener('input', () => {
    customGestureHandlerPinchInput.disabled = !customGestureHandlerInput.checked;
    customGestureHandlerReleaseInput.disabled = !customGestureHandlerInput.checked;
});
settingsForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const urlParams = new URLSearchParams(document.location.search);
    if (isEmulationMode(urlParams)) {
        ui2dDivElement.hidden = true;
    }
    initXR();
    await init();
    saveSettings();
});
// console.log("Hello world!");
//
// const defaultText = {
//     a: 1974,
//     b: 1.10,
//     c: "Dmitry",
// };
// console.log("defaultText", defaultText);
//
// const overload = {
//     a: 1973,
//     c: "Tanya",
//     d: "Hello",
// };
// console.log("overload", overload);
// console.log("overload stringified", JSON.stringify(overload));
//
// const overload2 = undefined;
//
// const result = Object.assign({}, defaultText, overload, overload2);
// console.log("result", result);
// const x = {
//     lobby_upcomingEvents: "UPCOMING EVENTS",
//     lobby_tags_header: "CATEGORIES",
// };
// console.log(JSON.stringify(x));
//
// let xx: string;
// // @ts-ignore
// const xxx = JSON.parse(xx || "{}");
// console.log(xxx);
// console.log("Hi");
const logSpan = document.getElementById("log");
const log = console.log;
console.log = (...data) => {
    log(...data);
    logSpan.innerHTML += `<p>${data}</p>`;
};
const warn = console.warn;
console.warn = (...data) => {
    warn(...data);
    logSpan.innerHTML += `<p style='color:yellow'>${data}</p>`;
};
const error = console.error;
console.error = (...data) => {
    error(...data);
    logSpan.innerHTML += `<p style='color:red'>${data}</p>`;
};
document.addEventListener("keydown", (ev) => {
    if (ev.ctrlKey && ev.shiftKey && ev.key === "Q") {
        webXRCanvasElement.hidden = !webXRCanvasElement.hidden;
    }
});
window.enterXRAsync = async () => await getCore().enterXRAsync();
